import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@app/services/auth.service';
import { ROUTE_PATH } from '@shared/enum/common.enum';

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isAuthenticated()) {
        return true;
    } else {
        router.navigate([ROUTE_PATH.LOGIN]);

        return false;
    }
};
